import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import React from 'react'
import './LinearProgressBar.css'
function LinearProgressBar({ value }) {
  const progress = value || 0

  const getColor = (progress) => {
    if (progress > 80) return 'success'
    if (progress >= 60) return 'warning'
    return 'error'
  }

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center' }}
      className="linear-progress-bar"
    >
      <Box sx={{ width: '103px', mr: 1 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          color={getColor(progress)}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${progress}%`}
        </Typography>
      </Box>
    </Box>
  )
}

export default LinearProgressBar
